import styled from 'styled-components'

export const ProductDownloadWrapper = styled.div`
  padding: 128px 0 96px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    padding: 146px 0 96px 0;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 146px 0 64px 0;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 96px 0 48px 0;
  }

  .ProductDownload__Download-Container {
    width: 485px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: 100%;
      max-width: 541px;
      margin: 0 auto;
    }
  }

  .ProductDownload__Heading {
    margin: 0 0 48px 0;
    color: ${({ theme }) => theme.webMktNewPalette.black};
    letter-spacing: -2px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      margin: 0 0 24px 0;
    }
  }

  .ProductDownload__Featured-Image-Container {
    width: 588px;
    height: 588px;
    position: relative;

    ${({ theme }) => theme.breakpoints.down('md')} {
      display: none;
    }

    .ProductDownload__Featured-Image-Macaroni {
      position: absolute;
      bottom: 36px;
      right: 208px;
      width: 678px;
      min-width: 678px;
      height: auto;
      z-index: 1;
    }
  }

  .ProductDownload__Featured-Image-File {
    width: 100%;
    height: auto;
    z-index: 0;
  }
`

export const ThankYouWrapper = styled.div`
  padding: 96px 0 0 0;
`
